<template>
  <div>
    <div v-if="formResponse">
      <a @click="viewResponse">{{ formResponse.name }}</a>
    </div>

    <v-bottom-sheet scrollable v-model="responseDialog">
      <v-card>
        <v-card-actions class="justify-center">
          <v-btn class="mt-2" @click="responseDialog = false" text>
            Close
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <div v-if="formResponse">
            <div class="text-subtitle-2 text-lg-h6">
              {{ formResponse.rpName }}'s responses to the
              {{ formResponse.name }} @ {{ formResponse.centerName }}.
            </div>
            <div class="text-caption pt-2">
              Submitted on {{ formResponse.submittedAt | formatDateTime }}
            </div>
            <form-response-details
              :submission="formResponse"
              :key="formResponse.id"
            />
          </div>

          <div v-else>
            <v-progress-circular
              indeterminate
              color="green"
            ></v-progress-circular>
            Loading response...
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
const FormResponseDetails = () =>
  import("@/components/forms/FormResponseDetails.vue");

export default {
  props: {
    token: {
      type: String,
      required: false,
    },
    responseId: {
      type: Number,
      required: false,
    },
  },
  components: { FormResponseDetails },
  data() {
    return {
      responseDialog: false,
      formResponse: null,
    };
  },
  filters: {
    formatDateTime(date) {
      return moment.utc(date).local().format("ddd, MMM DD, YYYY h:mm a");
    },
  },
  mounted() {
    if (this.token) {
      this.lookupFormResponseWithUuid();
    } else {
      this.lookupFormResponseWithId();
    }
  },
  computed: {
    ...mapGetters("auth", ["currentUser", "isAppLoading"]),
  },
  methods: {
    lookupFormResponseWithUuid() {
      const params = { uuid: this.token };
      this.$axios
        .get("/public/form/form-with-answer", { params })
        .then((resp) => {
          this.formResponse = resp.data.data;
        });
    },
    lookupFormResponseWithId() {
      const params = { id: this.responseId };
      this.$axios.get("/form/form-with-answer", { params }).then((resp) => {
        this.formResponse = resp.data.data;
      });
    },

    viewResponse() {
      this.responseDialog = true;
    },
  },
};
</script>

<style>
</style>